import React from "react";
import { Dropdown } from "react-bootstrap";
import {
  ArrowDownIcon,
  NeutralIcon,
  PositiveIcon,
  NegativeIcon,
  DefaultSentimentIcon,
} from "../../Icons/icons.component";
import {
  THEME_LABEL,
  TONE_LABEL,
  UNSET_THEME_LABEL,
  UNSET_TONE_LABEL,
} from "../../../constants/app-constant";

export function TonalityTag({
  label,
  defaultValue,
  onSelect,
  options,
  optionsFor,
  defaultTonalityList,
  newsDetails,
  hideUnsetOption,
  isSocial,
  isBlogAndForum,
  forBulkUpdate,
  isPrintAndOnline,
  isDisabled,
}) {
  let optionsList = options || [];

  const onSelectItem = (item) => {
    let tempItem = item;
    if ((isSocial || isBlogAndForum) && item == "Informative") {
      tempItem = "Neutral";
    }
    onSelect(tempItem);
  };

  const getClass = () => {
    if (defaultValue === "Positive") {
      return "positiveDropDown";
    }
    if (defaultValue === "Negative") {
      return "negativeDropDown";
    }
    if (defaultValue === "Informative" || defaultValue === "Neutral") {
      return "neutralDropDown";
    }
    return "";
  };

  const faceValue =
    !defaultValue || defaultValue === UNSET_TONE_LABEL ? label : defaultValue;

  const getOptionClass = () => {
    if (!(isPrintAndOnline && forBulkUpdate)) {
      if (!defaultValue || defaultValue === UNSET_TONE_LABEL) {
        return "disabled";
      }
    }
    return "";
  };

  const getLabel = () => {
    if (!isPrintAndOnline) {
      if (!defaultValue || defaultValue === UNSET_TONE_LABEL) return label;
    }
    return UNSET_TONE_LABEL;
  };

  return (
    <>
      {isDisabled ? (
        defaultValue && <span>{defaultValue}</span>
      ) : (
        <Dropdown className={`tonalityDropdown ${getClass()}`} alignRight>
          <Dropdown.Toggle variant="default" disabled={isDisabled}>
            {
              <TonalityIcon
                text={faceValue}
                showText={newsDetails}
                optionsList={optionsList}
              />
            }
            <ArrowDownIcon />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {!hideUnsetOption && (
              <Dropdown.Item
                onSelect={() => {
                  onSelectItem(UNSET_TONE_LABEL);
                }}
                value={"-1"}
                className={getOptionClass()}
              >
                {getLabel()}
              </Dropdown.Item>
            )}
            {optionsList &&
              optionsList.map((option, index) => {
                if (!option) {
                  return null;
                }
                return (
                  <Dropdown.Item
                    onSelect={() => {
                      onSelectItem(option);
                    }}
                    key={option.toLowerCase()}
                    value={option}
                  >
                    <TonalityIcon
                      text={option}
                      showText
                      optionsList={optionsList}
                    />
                  </Dropdown.Item>
                );
              })}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}

const TonalityIcon = ({ text, showText, optionsList }) => {
  let tempText = text;
  //https://webonise.atlassian.net/browse/CB-614
  if (text == "Informative") {
    tempText = "Neutral";
  }
  const renderIcon = () => {
    if (tempText == "Informative" || tempText == "Neutral") {
      return <NeutralIcon />;
    } else if (tempText == "Negative") return <NegativeIcon />;
    else if (tempText == "Positive") return <PositiveIcon />;
    return <DefaultSentimentIcon />;
  };
  return (
    <>
      {renderIcon()}
      {showText && tempText}
    </>
  );
};
